module.exports = __webpack_public_path__ + "static/media/night.d4d7158d.png";